import { Card, CardContent, Skeleton, Stack } from '@mui/material';
import React from 'react';

export const MetricCardSkeleton = () => {
  return (
    <Card
      elevation={0}
      sx={{
        width: '100%',
        borderRadius: '6px',
        border: '1px solid #e4e4e7',
        bgcolor: '#ffffff',
        boxShadow: 'none',
        height: { xs: 275, sm: 295, lg: 310 },
      }}
    >
      <CardContent sx={{ p: 2.5, height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Stack spacing={1.5} sx={{ flex: 1 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Skeleton variant="rounded" width="40%" height={16} sx={{ borderRadius: '4px' }} />
            <Skeleton variant="rounded" width="30%" height={24} sx={{ borderRadius: '4px' }} />
          </Stack>
          <Skeleton variant="rounded" width="100%" sx={{ flex: 1, borderRadius: '4px' }} />
        </Stack>
      </CardContent>
    </Card>
  );
};
